import React from "react";
import { useParams, useNavigate } from "react-router-dom";

// ✅ Import ALL staff form view pages
import StaffFormViewCompanyOverview from "./StaffFormViewCompanyOverview";
import StaffFormViewRepresentative from "./StaffFormViewRepresentative";
import StaffFormViewPaymentHandling from "./StaffFormViewPaymentHandling";
import StaffFormViewProducts from "./StaffFormViewProducts";
import StaffFormViewSalesMethod from "./StaffFormEditSalesMethod";
import StaffFormViewStoreList from "./StaffFormViewStoreList";
import StaffFormViewContactPerson from "./StaffFormViewContactPerson";

export {}; // module safety

export default function StaffFormRouter() {
  const navigate = useNavigate();
  const { merchantId, formKey } = useParams<{
    merchantId: string;
    formKey: string;
  }>();

  // ❌ Invalid URL guard
  if (!merchantId || !formKey) {
    return (
      <div style={{ padding: 16 }}>
        <div style={{ fontWeight: 900, color: "#b91c1c" }}>
          URLが正しくありません。
        </div>
        <button
          onClick={() => navigate("/staff/progress")}
          style={{
            marginTop: 10,
            padding: "10px 14px",
            borderRadius: 10,
            border: "1px solid #cbd5e1",
            background: "#fff",
            fontWeight: 900,
            cursor: "pointer",
          }}
        >
          進捗一覧へ戻る
        </button>
      </div>
    );
  }

  // ✅ Route by form key
  switch (formKey) {
    case "form1_company_overview":
      return <StaffFormViewCompanyOverview />;

    case "form2_representative":
      return <StaffFormViewRepresentative />;

    case "form3_payment_handling":
      return <StaffFormViewPaymentHandling />;

    case "form4_products":
      return <StaffFormViewProducts />;

    case "form5_sales_method":
      return <StaffFormViewSalesMethod />;

    case "form6_store_list":
      return <StaffFormViewStoreList />;

    case "form7_contact_person":
      return <StaffFormViewContactPerson />;

    // ❌ Fallback (should not happen once all are wired)
    default:
      return (
        <div style={{ padding: 16 }}>
          <div style={{ fontWeight: 900, color: "#b91c1c" }}>
            対応していないフォームです：{formKey}
          </div>
          <button
            onClick={() => navigate(`/staff/progress/${merchantId}`)}
            style={{
              marginTop: 10,
              padding: "10px 14px",
              borderRadius: 10,
              border: "1px solid #cbd5e1",
              background: "#fff",
              fontWeight: 900,
              cursor: "pointer",
            }}
          >
            進捗詳細へ戻る
          </button>
        </div>
      );
  }
}
